import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSidebarHiddenRightWide: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconSidebarHiddenRightWide"><Path fillRule="evenodd" clipRule="evenodd" d="M2 20H22V4H2V20ZM18.5 7.5V16.5H17V7.5H18.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconSidebarHiddenRightWide;
